"use client";
import { useEffect, useState } from "react";
import { FaLocationDot } from "react-icons/fa6";
import { CONSENT_EVENT, hasCookieConsent } from "./cookie/CookieBanner";
import Link from "next/link";

const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2572.194882495442!2d7.982993676366877!3d49.857583771485054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bdf3c888fdbb75%3A0x7cfda4a4f6cc0a05!2sBadenheimer%20Str.%204%2C%2055576%20Sprendlingen!5e0!3m2!1sde!2sde!4v1734986086037!5m2!1sde!2sde";
const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Badenheimer+Str.+4,+55576+Sprendlingen,+Deutschland";

// Google-Karte erst nach Zustimmung laden – vorher ein Platzhalter mit Knopf
const MapEmbed = () => {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const update = () => setAllowed(hasCookieConsent());
    update();
    window.addEventListener(CONSENT_EVENT, update);
    return () => window.removeEventListener(CONSENT_EVENT, update);
  }, []);

  const loadOnce = () => setAllowed(true);

  return (
    <div className="overflow-hidden rounded-2xl border border-ao-line lg:rounded-3xl">
      {allowed ? (
        <iframe
          title="Karte: A und O Autoservice, Badenheimer Str. 4, Sprendlingen"
          src={MAP_SRC}
          className="block h-[280px] w-full lg:h-[400px] dark:[filter:invert(90%)_hue-rotate(180deg)_grayscale(30%)]"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      ) : (
        <div className="flex h-[280px] flex-col items-center justify-center gap-4 bg-ao-surface px-6 text-center lg:h-[400px]">
          <FaLocationDot className="text-4xl text-ao-accent-fg" />
          <p className="max-w-sm text-sm leading-relaxed text-ao-muted">
            Mit dem Laden der Karte wird eine Verbindung zu Google hergestellt,
            und Ihre IP-Adresse wird an Google übertragen. Mehr in der{" "}
            <Link
              href="/datenschutz"
              className="font-semibold text-ao-fg underline"
            >
              Datenschutzerklärung
            </Link>
            .
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={loadOnce}
              className="flex h-11 items-center justify-center rounded-[10px] bg-ao-accent px-5 text-sm font-bold text-ao-on-accent transition-colors hover:bg-ao-accent-hover"
            >
              Karte laden
            </button>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 items-center justify-center rounded-[10px] border border-ao-line-strong px-5 text-sm font-semibold transition-colors hover:border-ao-accent"
            >
              In Google Maps öffnen
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapEmbed;
